export default "__VITE_ASSET__3eYN0TKe__"